<div class="folder-browser">
  <div class="folder-browser__toolbar">
    <!-- Breadcrumbs render only when there's drill-down beyond the root crumb. With a single
         crumb (the user is at the root), the lone "Documents" label is redundant with the
         tab/page header context and just adds visual noise. -->
    <nav
      class="folder-browser__crumbs"
      [attr.aria-label]="'DOCUMENT_MANAGEMENT.BREADCRUMBS_ARIA_LABEL' | translate">
      @if (breadcrumbs().length > 1) {
        @for (crumb of breadcrumbs(); track $index; let isLast = $last) {
          @if ($index > 0) {
            <i class="pi pi-chevron-right folder-browser__crumb-sep" aria-hidden="true"></i>
          }
          <button
            type="button"
            class="folder-browser__crumb"
            [class.folder-browser__crumb--current]="isLast"
            [disabled]="isLast"
            (click)="onCrumbClick($index)">
            {{ crumb.label }}
          </button>
        }
      }
    </nav>
    <div class="folder-browser__toolbar-actions">
      <label class="folder-browser__tags-label" for="folder-browser-show-tags">
        {{ 'DOCUMENT_MANAGEMENT.SHOW_TAGS_LABEL' | translate }}
        <p-checkbox
          inputId="folder-browser-show-tags"
          [ngModel]="showTags()"
          (ngModelChange)="onShowTagsChange($event)"
          [binary]="true" />
      </label>
      <label class="folder-browser__sort-label" for="folder-browser-sort">
        {{ 'DOCUMENT_MANAGEMENT.SORT_BY_LABEL' | translate }}
      </label>
      <p-select
        inputId="folder-browser-sort"
        styleClass="folder-browser__sort-select"
        [appendTo]="'body'"
        [options]="sortOptions()"
        optionLabel="label"
        optionValue="value"
        [ngModel]="folderSort()"
        (ngModelChange)="onFolderSortChange($event)" />
    </div>
  </div>

  <div class="folder-browser__columns">
    @for (column of columns(); track $index) {
      @if (column.smart; as smartKind) {
        <tf-smart-list-column
          [kind]="smartKind"
          [selectedChildId]="column.selectedChildId"
          [selectedDocumentId]="column.selectedDocumentId"
          [reloadKey]="column.reloadKey"
          [showTags]="showTags()"
          (folderSelected)="onFolderSelected($index, $event)"
          (documentSelected)="onDocumentSelected($index, $event)"
          (focusOutOfBounds)="onColumnFocusOutOfBounds($index, $event)" />
      } @else {
        <tf-folder-column
          [parentId]="column.parentId"
          [folderKind]="column.parentKind ?? null"
          [selectedChildId]="column.selectedChildId"
          [selectedDocumentId]="column.selectedDocumentId"
          [reloadKey]="column.reloadKey"
          [headerLabel]="columnHeaderLabel(column, $index)"
          [busy]="isCreatingFolder()"
          [showSmartEntries]="$index === 0 && column.parentId === null"
          [selectedSmart]="column.selectedSmart ?? null"
          [sortKey]="folderSort()"
          [showTags]="showTags()"
          (folderSelected)="onFolderSelected($index, $event)"
          (documentSelected)="onDocumentSelected($index, $event)"
          (newFolderRequested)="onNewFolderRequested($event)"
          (smartSelected)="onSmartSelected($index, $event)"
          (moveCompleted)="onMoveCompleted($event)"
          (bodyBackgroundClicked)="onColumnBackgroundClicked($index)"
          (focusOutOfBounds)="onColumnFocusOutOfBounds($index, $event)" />
      }
    }
    <tf-detail-pane
      class="folder-browser__detail"
      [selection]="selection()"
      [folderChildCounts]="folderChildCounts()"
      [starredIds]="starredIds()"
      [starError]="starError()"
      (starToggled)="onToggleStar($event)"
      (recentDocumentClicked)="onRecentDocumentClicked($event)"
      (renamed)="onRenamed($event)"
      (tagsUpdated)="onTagsUpdated($event)"
      (softDeleted)="onLifecycleChanged($event)"
      (hardDeleted)="onHardDeleted($event)"
      (restored)="onDocumentRestored($event)" />
  </div>

  <tf-new-folder-dialog
    [visible]="newFolderDialogVisible()"
    [isSaving]="isCreatingFolder()"
    [errorMessage]="newFolderError()"
    (save)="onNewFolderSave($event)"
    (cancelled)="onNewFolderCancel()"
    (visibilityChange)="onNewFolderVisibilityChange($event)" />
</div>
